const env = {
  DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN,
  CLIENTID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE,
};

export default env;
